<script setup lang="ts">
    import { ref, onMounted } from 'vue';
    import { gsap } from 'gsap';
    import { useWindowScroll } from '@vueuse/core';

    const scrollElement = ref(null);
    const animDuration = 0.4;

    const { y } = useWindowScroll();
    const isScrolledDown = computed(() => (y.value || 0) > 32);

    onMounted(() => {
        const scrollAnimTl = gsap.timeline({
            repeat: -1,
            repeatDelay: animDuration * 2
        });
        scrollAnimTl.to(scrollElement.value, {
            opacity: 1,
            y: 8.33,
            duration: animDuration,
            ease: 'linear'
        });
        scrollAnimTl.to(scrollElement.value, {
            y: 16.66,
            duration: animDuration,
            ease: 'linear'
        });
        scrollAnimTl.to(scrollElement.value, {
            opacity: 0,
            y: 25,
            duration: 0.33,
            ease: 'linear'
        });
    });

    const scrollDown = () => {
        const viewportHeight = window.innerHeight;
        window.scrollTo({
            top: viewportHeight,
            left: 0,
            behavior: 'smooth'
        });
    };
</script>

<template>
    <button
        :class="{ 'scroll-down': true, hidden: isScrolledDown }"
        @click="scrollDown"
    >
        <p class="sr-only">Zur Top Story scrollen</p>
        <svg
            style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2"
            viewBox="0 0 48 48"
        >
            <path
                d="M0 50.014c-5.544 0-10.038-4.494-10.038-10.038V3.457C-10.038-2.087-5.544-6.582 0-6.582c5.544 0 10.039 4.495 10.039 10.039v36.519c0 5.544-4.495 10.038-10.039 10.038Zm0-3.9a6.139 6.139 0 0 0 6.139-6.138V3.457a6.139 6.139 0 1 0-12.277 0v36.519A6.138 6.138 0 0 0 0 46.114Z"
                style="fill: #fff"
                transform="matrix(.84811 0 0 .84811 22.475 5.583)"
            />
            <path
                ref="scrollElement"
                d="M0 22.067a2.9 2.9 0 0 1-2.899-2.899V2.898a2.898 2.898 0 0 1 5.798 0v16.27A2.9 2.9 0 0 1 0 22.067"
                style="fill: #fff; fill-rule: nonzero; opacity: 0"
                transform="matrix(.84811 0 0 .84811 22.475 6.134)"
            />
        </svg>
    </button>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/hero-section/hero-scroll-down.scss';
</style>
